import { LimitOrderForm } from 'components/secondaryMarket/limitOrder/LimitOrderForm';
import { formConnectFactory } from 'components/Workspaces/SecondaryMarketQuotes/Tabs/shared/Form.connect';
import { connect } from 'react-redux';
import { limitOrderSelectors } from 'state/secondaryMarket/limit-order/limitOrder.selector';
import { limitOrderThunks } from 'state/secondaryMarket/limit-order/limitOrder.thunk';
import { limitOrderReferentialSelectors } from 'state/secondaryMarket/limit-order/referential/referential.selector';

const { mapStateToProps, mapDispatchToProps } = formConnectFactory(
  limitOrderReferentialSelectors,
  limitOrderSelectors,
  limitOrderThunks,
);

export const ConnectedLimitOrderForm = connect(mapStateToProps, mapDispatchToProps)(LimitOrderForm);
